/**
 * 놀이터 왼쪽 칸 — Bench micro:bit 편집기를 '시뮬레이터만 보기'로 담는다(PICNIC-MB-FIELD-001 1단계 화면 · Bench `?view=sim`).
 * 입장표 주소(`…/student/editor/{id}#ticket=…&returnUrl=…`)의 조각 앞에 질의 `view=sim` 을 끼운다 — 조각(입장표)은 그대로 둔다.
 * Bench 는 이 질의를 micro:bit 편집기까지 넘기고, 그 칸은 저장하지 않는 재생 전용이다(고치기는 'Bench 에서 고치기' 탭).
 */
export function simViewUrl(editorUrl: string): string {
  const hash = editorUrl.indexOf("#");
  const head = hash < 0 ? editorUrl : editorUrl.slice(0, hash);
  const frag = hash < 0 ? "" : editorUrl.slice(hash);
  return `${head}${head.includes("?") ? "&" : "?"}view=sim${frag}`;
}

/** iframe 권한 — Campus 의 Bench 임베드와 같은 값(MakeCode 까지 위임된다 · 카메라는 주지 않는다) */
export const SIM_FRAME_ALLOW = "usb; serial; bluetooth; autoplay; fullscreen; microphone";
export const SIM_FRAME_SANDBOX = "allow-scripts allow-same-origin allow-forms allow-downloads";
